import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { BrokenContainerReportFieldsFragmentDoc } from '../fragments/brokenContainerReport.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ContainerBrokenReportsQueryVariables = Types.Exact<{
  containerId: Types.Scalars['UUID'];
}>;


export type ContainerBrokenReportsQuery = { __typename?: 'Query', containerBrokenReports?: Array<{ __typename?: 'BrokenContainerReport', id: string, store_id: string, store_name?: string | null, context: Types.BrokenContainerReportContext, merchant_order_id?: string | null, merchant_order_delivery_note_id?: number | null, comment?: string | null, created_at: string, created_by?: string | null, container_total: number, lines: Array<{ __typename?: 'BrokenContainerLine', id: string, container_type_id: number, container_type_name?: string | null, image_url?: string | null, amount: number, part: Types.BrokenContainerPart, active?: boolean | null, cleared_at?: string | null, cleared_by?: string | null, container?: { __typename?: 'ReturnOrderContainer', id: string, name?: string | null, short_id?: string | null } | null, photos: Array<{ __typename?: 'OrderFulfillmentPicture', id: string, url_full_size: string, created_at: string, thumbnail_url: string }> }>, photos: Array<{ __typename?: 'OrderFulfillmentPicture', id: string, url_full_size: string, created_at: string, thumbnail_url: string }> }> | null };


export const ContainerBrokenReportsDocument = gql`
    query ContainerBrokenReports($containerId: UUID!) {
  containerBrokenReports(container_id: $containerId) {
    ...BrokenContainerReportFields
  }
}
    ${BrokenContainerReportFieldsFragmentDoc}`;

/**
 * __useContainerBrokenReportsQuery__
 *
 * To run a query within a React component, call `useContainerBrokenReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerBrokenReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerBrokenReportsQuery({
 *   variables: {
 *      containerId: // value for 'containerId'
 *   },
 * });
 */
export function useContainerBrokenReportsQuery(baseOptions: Apollo.QueryHookOptions<ContainerBrokenReportsQuery, ContainerBrokenReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContainerBrokenReportsQuery, ContainerBrokenReportsQueryVariables>(ContainerBrokenReportsDocument, options);
      }
export function useContainerBrokenReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContainerBrokenReportsQuery, ContainerBrokenReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContainerBrokenReportsQuery, ContainerBrokenReportsQueryVariables>(ContainerBrokenReportsDocument, options);
        }
export type ContainerBrokenReportsQueryHookResult = ReturnType<typeof useContainerBrokenReportsQuery>;
export type ContainerBrokenReportsLazyQueryHookResult = ReturnType<typeof useContainerBrokenReportsLazyQuery>;
export type ContainerBrokenReportsQueryResult = Apollo.QueryResult<ContainerBrokenReportsQuery, ContainerBrokenReportsQueryVariables>;